import React from 'react';
import { formatCurrency } from '@avila-tek/ui/src';
import fallbackImg from '../../../public/images/product-card-fallback.png';

interface LeaderBoardRowProps {
  amount: number;
  amountType: 'number' | 'money';
  photoSrc: string;
  name: string;
}

function LeaderBoardRow({
  amount,
  amountType,
  name,
  photoSrc,
}: LeaderBoardRowProps) {
  return (
    <>
      <div className="w-full flex items-center">
        <div className="">
          <img
            alt="user"
            src={photoSrc === '' ? fallbackImg.src : photoSrc}
            className="w-12 h-12 rounded-full object-cover"
          />
        </div>
        <div className="ml-3">
          <span className="text-text-black font-semibold">{name}</span>
        </div>
        <div className="ml-auto">
          <span className="text-text-gray text-lg font-semibold">
            {amountType === 'number' ? amount : `$${formatCurrency(amount)}`}
          </span>
        </div>
      </div>
      <hr className="my-3" />
    </>
  );
}

export default LeaderBoardRow;
